<template>
  <div class="index">
    <HeaderBar ref="HeaderBar"></HeaderBar>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderBar from "@/components/header";
import Footer from "@/components/footer";
export default {
  components: {
    HeaderBar,
    Footer,
  },
  data() {
    return {};
  },
  // watch: {
  //   $route(to, from) {
  //     location.reload();
  //   },
  // },
  created() {
    // console.log(this.$route.path)
  },
  beforeMount() {
    if (this.$route.meta.title) {
      // 设置页面title
      document.title = this.$route.meta.title;
    }
  },
  created() {

  },
  methods: {
     
  }
};
</script>

<style lang="less">
.index {
  position: relative;
  margin: 0;
  min-height: 100vh;
  // background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue